import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'login';

export const submitLogin = createAction(`${ACTION_PREFIX}/SUBMIT_LOGIN`);
export const submitLoginSucceeded = createAction(`${ACTION_PREFIX}/SUBMIT_LOGIN_SUCCEEDED`);
export const submitLoginFailed = createAction(`${ACTION_PREFIX}/SUBMIT_LOGIN_FAILED`);
export const setRequiresCaptcha = createAction(`${ACTION_PREFIX}/SET_REQUIRES_CAPTCHA`);
export const updateFields = createAction(`${ACTION_PREFIX}/UPDATE_FIELDS`);

export const LoginActions = {
  submitLogin,
  submitLoginSucceeded,
  submitLoginFailed,
  setRequiresCaptcha,
  updateFields,
};
